import { createPlugin, key } from './pm-plugins/main';

/**
 * Focus plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 */
export var focusPlugin = function focusPlugin(_ref) {
  var api = _ref.api;
  return {
    name: 'focus',
    getSharedState: function getSharedState(editorState) {
      var _key$getState;
      if (!editorState) {
        return {
          hasFocus: false
        };
      }
      return {
        hasFocus: Boolean((_key$getState = key.getState(editorState)) === null || _key$getState === void 0 ? void 0 : _key$getState.hasFocus)
      };
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'focusHandlerPlugin',
        plugin: createPlugin
      }];
    }
  };
};